/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProposalSaasConfigDto } from '../models/proposal-saas-config-dto';
import { SaaSServiceDto } from '../models/saa-s-service-dto';

@Injectable({
  providedIn: 'root',
})
export class ProposalSaasConfigurationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation saveProposalSaasConfigForApprovedPropsl
   */
  static readonly SaveProposalSaasConfigForApprovedPropslPath = '/api/v1/proposal/saasConfig';

  /**
   * Save Proposal Saas Config.
   *
   * This API is used to save approved proposal Saas configurations.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveProposalSaasConfigForApprovedPropsl()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveProposalSaasConfigForApprovedPropsl$Response(params: {
    body: ProposalSaasConfigDto
  }): Observable<StrictHttpResponse<ProposalSaasConfigDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProposalSaasConfigurationService.SaveProposalSaasConfigForApprovedPropslPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProposalSaasConfigDto>;
      })
    );
  }

  /**
   * Save Proposal Saas Config.
   *
   * This API is used to save approved proposal Saas configurations.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `saveProposalSaasConfigForApprovedPropsl$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveProposalSaasConfigForApprovedPropsl(params: {
    body: ProposalSaasConfigDto
  }): Observable<ProposalSaasConfigDto> {

    return this.saveProposalSaasConfigForApprovedPropsl$Response(params).pipe(
      map((r: StrictHttpResponse<ProposalSaasConfigDto>) => r.body as ProposalSaasConfigDto)
    );
  }

  /**
   * Path part for operation saveProposalSaasConfig
   */
  static readonly SaveProposalSaasConfigPath = '/api/v1/proposal/saasConfig';

  /**
   * Save Proposal Saas Config.
   *
   * This API is used to save proposal Saas configurations.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveProposalSaasConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveProposalSaasConfig$Response(params: {
    body: ProposalSaasConfigDto
  }): Observable<StrictHttpResponse<ProposalSaasConfigDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProposalSaasConfigurationService.SaveProposalSaasConfigPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProposalSaasConfigDto>;
      })
    );
  }

  /**
   * Save Proposal Saas Config.
   *
   * This API is used to save proposal Saas configurations.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `saveProposalSaasConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveProposalSaasConfig(params: {
    body: ProposalSaasConfigDto
  }): Observable<ProposalSaasConfigDto> {

    return this.saveProposalSaasConfig$Response(params).pipe(
      map((r: StrictHttpResponse<ProposalSaasConfigDto>) => r.body as ProposalSaasConfigDto)
    );
  }

  /**
   * Path part for operation getAllSaaSService
   */
  static readonly GetAllSaaSServicePath = '/api/v1/saasServices';

  /**
   * Get All Saas Services.
   *
   * This API is used to fetch all the Saas services.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSaaSService()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSaaSService$Response(params?: {
  }): Observable<StrictHttpResponse<Array<SaaSServiceDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ProposalSaasConfigurationService.GetAllSaaSServicePath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SaaSServiceDto>>;
      })
    );
  }

  /**
   * Get All Saas Services.
   *
   * This API is used to fetch all the Saas services.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllSaaSService$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSaaSService(params?: {
  }): Observable<Array<SaaSServiceDto>> {

    return this.getAllSaaSService$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SaaSServiceDto>>) => r.body as Array<SaaSServiceDto>)
    );
  }

  /**
   * Path part for operation findByProposalId
   */
  static readonly FindByProposalIdPath = '/api/v1/proposal/{proposalId}/saasConfig';

  /**
   * Get Proposal Saas Config.
   *
   * This API is used to fetch the Saas configurations for the specified proposal id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByProposalId()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByProposalId$Response(params: {
    proposalId: string;
  }): Observable<StrictHttpResponse<ProposalSaasConfigDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProposalSaasConfigurationService.FindByProposalIdPath, 'get');
    if (params) {
      rb.path('proposalId', params.proposalId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProposalSaasConfigDto>;
      })
    );
  }

  /**
   * Get Proposal Saas Config.
   *
   * This API is used to fetch the Saas configurations for the specified proposal id.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findByProposalId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByProposalId(params: {
    proposalId: string;
  }): Observable<ProposalSaasConfigDto> {

    return this.findByProposalId$Response(params).pipe(
      map((r: StrictHttpResponse<ProposalSaasConfigDto>) => r.body as ProposalSaasConfigDto)
    );
  }

}
